var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRoofFlat = function SvgRoofFlat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,47.5 L17,34 C17,33.4477153 17.4477153,33 18,33 L25.971503,33 C26.5237878,33 26.971503,33.4477153 26.971503,34 L26.971503,47.5 L43,47.5 L43,22.1905395 C43,21.6382548 43.4477153,21.1905395 44,21.1905395 L45,21.1905395 C45.5522847,21.1905395 46,21.6382548 46,22.1905395 L46,47.9841893 C46,49.3787402 44.8616982,50.5 43.46875,50.5 L12.53125,50.5 C11.1383018,50.5 10,49.3787402 10,47.9841893 L10,22.1905395 C10,21.6382548 10.4477153,21.1905395 11,21.1905395 L12,21.1905395 C12.5522847,21.1905395 13,21.6382548 13,22.1905395 L13,47.5 L17,47.5 Z M20,47.5 L23.971503,47.5 L23.971503,36 L20,36 L20,47.5 Z M6,18 L6,17 C6,16.4477153 6.44771525,16 7,16 L49,16 C49.5522847,16 50,16.4477153 50,17 L50,18 C50,18.5522847 49.5522847,19 49,19 L7,19 C6.44771525,19 6,18.5522847 6,18 Z M33,39 L36.971503,39 L36.971503,36 L33,36 L33,39 Z M31,33 L38.971503,33 C39.5237878,33 39.971503,33.4477153 39.971503,34 L39.971503,41 C39.971503,41.5522847 39.5237878,42 38.971503,42 L31,42 C30.4477153,42 30,41.5522847 30,41 L30,34 C30,33.4477153 30.4477153,33 31,33 Z",
    fill: "currentColor"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoofFlat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/roof-flat.271444b8.svg";
export { ForwardRef as ReactComponent };